import {Button, ButtonProps} from "@web-libs/ui/ui-components/buttons/button";
import {WithColorSvgFunction} from "@web-libs/ui/svgs/fill/with-color";

type Suffix = {
    svg: WithColorSvgFunction,
    height?: number
    width?: number
}

type SuffixButtonProps = Omit<ButtonProps,"suffix"> & {
    suffix: Suffix
}
export const SuffixButton = (props: SuffixButtonProps) => {
    const {suffix, ...rest} = props

    const renderedSuffix = props.suffix.svg({})

    return <Button {...rest} suffix={renderedSuffix} />
}
